import { useTranslation } from 'react-i18next';
import { QrCodeModal } from 'ui';
import { getSafeFileName } from 'common/utils';
import { useGetInvitationTokenQuery } from 'features/invitation-tokens';
import { useGenerateInvitationLink, useGetInvitationTokenKind } from '../hooks';

type P = {
  eventId: string;
  eventName: string;
  isOpened: boolean;
  onCancel: () => void;
  type: 'attendee' | 'presenter';
};

const getTitle = (type: 'attendee' | 'presenter') => {
  switch (type) {
    case 'attendee':
      return 'Invite attendee via QR code';
    case 'presenter':
      return 'Invite presenter via QR code';
  }
};

const ShareQrCodeModal = ({ eventId, eventName, isOpened, onCancel, type }: P) => {
  const { t } = useTranslation();
  const getInvitationTokenKind = useGetInvitationTokenKind();
  const fileName = `${getSafeFileName({ name: eventName })} ${t('Invitation QR Code')}`;
  const generateInvitationLink = useGenerateInvitationLink();

  const {
    data: invitationToken,
    error,
    isFetching,
  } = useGetInvitationTokenQuery({
    kind: getInvitationTokenKind({ type }),
    options: { enabled: isOpened, staleTime: 0, throwOnError: false },
    subjectId: eventId,
    subjectType: 'Event',
  });

  return (
    <QrCodeModal
      alerts={[
        {
          description:
            'You can display the QR code for someone nearby, share it through messaging apps, or download it to your device for later use',
        },
        {
          description:
            'By scanning the QR code, the recipient can accept the invitation and join the platform seamlessly. The process is quick and straightforward.',
        },
      ]}
      error={error}
      fileName={fileName}
      isLoading={isFetching}
      isOpened={isOpened}
      onCancel={onCancel}
      qrCodeValue={generateInvitationLink({ eventId, token: invitationToken?.token ?? '' })}
      title={getTitle(type)}
    />
  );
};

export default ShareQrCodeModal;
